import React from 'react';

import styles from './footer.module.scss';

import PrimaryButton from '../Buttons/primaryButton';
import Icon from '../icon';
import FacebookIcon from '../../img/icons/facebook-icon.svg';
import TwitterIcon from '../../img/icons/twitter-icon.svg';
import YoutubeIcon from '../../img/icons/youtube-icon.svg';
import InstagramIcon from '../../img/icons/instagram-icon.svg';


const Footer = (props) =>
{
  return (
    <footer className={styles.footer}>
        <div className="responsive-container">
            <div className={styles.footerContent}>
            <div className={styles.footerColumnContainer}>
                <div className={styles.footerColumn}>
                    <h4 className={styles.titleFooter}>Productos</h4>
                    <ul>
                        <li><a href="https://homyhub.com/" target="_blank">Qué es HOMYHUB</a></li>
                        <li><a href="https://homyhub.com/como-funciona/" target="_blank">¿Cómo funciona?</a></li>
                        <li><a href="https://homyhub.com/integraciones/" target="_blank">Integraciones</a></li>
                        <li><a href="https://homyhub.com/opiniones/" target="_blank">Opiniones</a></li>
                        <li><a href="https://homyhub.com/comprar/starter-kit-mando-de-garaje-homyhub/" target="_blank">Comprar</a></li>
                    </ul>
                </div>

                <div className={styles.footerColumn}>
                <h4 className={styles.titleFooter}>Soporte</h4>
                <ul>
                    <li><a href="https://homyhub.com/docs">FAQs</a></li>
                    <li><a href="mailto:hola@homyhub.com">Contacta</a></li>
                </ul>
                </div>

                <div className={styles.footerColumn}>
                <h4 className={styles.titleFooter}>Empresa</h4>
                <ul>
                    <li>
                    <a href="https://www.facebook.com/homyhub/" target="_blank">
                        <Icon src={FacebookIcon} />
                        Facebook
                    </a>
                    </li>
                    <li>
                    <a href="https://www.instagram.com/homyhub/" target="_blank">
                        <Icon src={InstagramIcon} />
                        Instagram
                    </a>
                    </li>
                    <li>
                    <a href="https://www.youtube.com/channel/UC-lbO6URMacQfk2QmnBW4Yw" target="_blank">
                        <Icon src={YoutubeIcon} />
                        Youtube
                    </a>
                    </li>
                    <li><a href="https://homyhub.com/blog/" target="_blank">Blog</a></li>
                </ul>
                </div>

                <div className={styles.footerLast}>
                <h4 className={styles.titleFooter}>Obtener</h4>
                <PrimaryButton
                    text="Consigue tu HOMYHUB"
                    onClick={() => window.open('https://homyhub.com/comprar/starter-kit-mando-de-garaje-homyhub/')}
                />
            </div>


            </div>

            <div className={styles.copyright}>
                <p>© 2024 HOMYHUB SL.<br/>Todos los derechos reservados.</p>
                <div className={styles.right}>
                    <a href="https://homyhub.com/politica-privacidad/" target="_blank">Política de privacidad<span>|</span></a>
                    <a href="https://homyhub.com/politica-de-cookies-ue/" target="_blank">Política de Cookies<span>|</span></a>
                    <a href="https://homyhub.com/terminos-y-condiciones/" target="_blank">Términos y condiciones</a>
                </div>
            </div>
            </div>


        </div>
    </footer>
    );
}

export default Footer;